import { render, staticRenderFns } from "./NewBarChart.vue?vue&type=template&id=e01255c4&"
import script from "./NewBarChart.vue?vue&type=script&lang=js&"
export * from "./NewBarChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports